import { Role } from '@guiker/permissions'

import { DocumentActions } from '../document-actions'
import { DocumentRoleNames } from '../role-names'

export const EditorRole: Role = {
  name: DocumentRoleNames.EDITOR,
  permissions: Object.values(DocumentActions).map((action) => ({ action })),
}
